export default __webpack_public_path__ + "static/media/Ballroll_00097.75ed96a4.png";